import { Component, OnInit, Input } from '@angular/core';
import { FormBaseComponent } from '../../core/component/form-base/form-base.component';
import { FormControl, Validators } from '@angular/forms';
import { ValidatorService } from '../../../core/service/app/validator.service';

@Component({
  selector: 'app-reference-form',
  templateUrl: './reference-form.component.html',
  styleUrls: ['./reference-form.component.scss']
})
export class ReferenceFormComponent extends FormBaseComponent<any> implements OnInit {

  @Input() mostrarTitulo = true;
  @Input() titulo = "";


  constructor(private validatorService: ValidatorService) {
    super();
   }

  ngOnInit() {
    this.init();
  }


  template(){
    this.form.addControl('name', new FormControl());
    this.form.addControl('contact', new FormControl());
    this.form.addControl('phone', new FormControl('', [this.validatorService.telReferencia]));
    this.form.addControl('cellPhone', new FormControl('', [this.validatorService.celular]));
    this.form.addControl('email', new FormControl('', [Validators.email]));
  }

}



// WEBPACK FOOTER //
// ./src/app/form/form/reference-form/reference-form.component.ts